import { DatePicker as FDatePicker } from "@fluentui/react";
import { useEffect, useState } from "react";

import { FilterComponentProps } from "./interfaces";

import { Space } from "@/components/Space";
import { formatDate } from "@/utils/FormatDate";

const onFormatDate = (date?: Date): string => {
  return !date ? "" : formatDate(date.toString());
};

export function DatePicker({
  setSelectedKeys,
  _paginate,
  filterConfigs,
  debouncedTerms,
  selectedKeys,
  itemsPerPage
}: FilterComponentProps): JSX.Element {
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  useEffect(() => {
    const filterQuery = selectedKeys[filterConfigs.filterQuery as string];

    if (!filterQuery && selectedDate) setSelectedDate(null);
  }, [filterConfigs.filterQuery, selectedDate, selectedKeys]);

  useEffect(() => {
    setSelectedDate(selectedDate);
  }, [selectedDate]);

  function handleDateChange(dateValue?: Date) {
    const currentKeys = { ...selectedKeys };
    const { filterQuery } = filterConfigs;

    if (dateValue) {
      const formatted = formatDate(dateValue.toString());
      currentKeys[filterQuery as string] = formatted;
      setSelectedDate(dateValue);
    } else {
      delete currentKeys[filterQuery as string];
      setSelectedDate(null);
    }
    setSelectedKeys(currentKeys);
    _paginate({
      limit: itemsPerPage ?? 10,
      ...debouncedTerms,
      ...currentKeys
    });
  }

  return (
    <Space customMargin="center">
      <FDatePicker
        disabled={Boolean(filterConfigs.disabled)}
        label={filterConfigs.label}
        placeholder={filterConfigs.placeholder}
        onSelectDate={handleDateChange}
        value={selectedDate}
        formatDate={onFormatDate}
        allowTextInput
        styles={{ statusMessage: { display: "none" } }}
        style={{ display: "flex", alignItems: "center" }}
      />
    </Space>
  );
}
